/**
 * Ticket Status Collection.
 *
 * Contains static list of available ticket's message types, which can be used for different
 * purposes, like filling lists, allowing options selection, etc.
 */
export default [
  {
    key: 0,
    value: '',
    icon: {
      name: 'dot',
    },
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
  {
    key: 10,
    value: 'New',
    icon: {
      name: 'dot',
    },
    color: 'pending.500',
    backgroundColor: 'pending.50',
  },
  {
    key: 30,
    value: 'Open',
    icon: {
      name: 'dot',
    },
    color: 'pending.500',
    backgroundColor: 'pending.50',
  },
  {
    key: 50,
    value: 'In progress',
    icon: {
      name: 'dot',
    },
    color: 'pending.700',
    backgroundColor: 'pending.50',
  },
  {
    key: 60,
    value: 'Pending',
    icon: {
      name: 'dot',
    },
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
  {
    key: 75,
    value: 'Solution proposed',
    icon: {
      name: 'dot',
    },
    color: 'success.700',
    backgroundColor: 'success.50',
  },
  {
    key: 80,
    value: 'Closed',
    icon: {
      name: 'dot',
    },
    color: 'gray.400',
    backgroundColor: 'gray.960',
  },
  {
    key: 90,
    value: '',
    icon: {
      name: 'dot',
    },
    color: 'error.700',
    backgroundColor: 'error.50',
  },
]
